export enum PaymentMethodType {
  CARD = 'C',
  PIX = 'P',
  BANK_SLIP = 'B',
}
